import withCustomChoice from "./hocs/withCustomChoice";
import BaseDropdown from "./BaseDropdown";

import "./styles.css";

const CustomChoiceDropdown = withCustomChoice(BaseDropdown);

export default CustomChoiceDropdown;
